import { useTranslation } from 'react-i18next';
import { Icon } from '@hp/ui';

/** Quiet in-progress marker: a pulsing dot with optional text (no spinners in this design system). */
export function Spinner({ className, children }: { className?: string; children?: React.ReactNode }) {
  return (
    <span className={className ? `bo-running ${className}` : 'bo-running'} aria-live="polite">
      {children}
    </span>
  );
}

/** Pipedrive logomark (white "P" on a disc); disc colour follows currentColor. */
export function PipedriveIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className ? `bo-pd-icon ${className}` : 'bo-pd-icon'} aria-hidden="true">
      <circle cx="12" cy="12" r="11" fill="currentColor" />
      <path d="M9.6 7.4v10.2" stroke="var(--hp-paper)" strokeWidth="2.7" strokeLinecap="round" fill="none" />
      <circle cx="12.7" cy="10.4" r="3.1" stroke="var(--hp-paper)" strokeWidth="2.7" fill="none" />
    </svg>
  );
}

export function LockIcon({ className }: { className?: string }) {
  const { t } = useTranslation();
  return <Icon name="lock" className={className} aria-label={t('misc.locked')} />;
}
